import Typography from '@material-ui/core/Typography';
import ConfirmModal from 'Components/Common/Modals/ConfirmModal';
import useAppSelector from 'Hooks/Redux/useAppSelector';
import useMessagesDispatch from 'Hooks/Redux/useMessagesDispatch';
import { UserResponse } from 'Models/User';
import { ReactElement } from 'react';
import { MessageStatusLevel } from 'Redux/Actions/Messages';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

interface DeleteUserModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	user: UserResponse | null;
}

const DeleteUserModal = ({ isOpen, onClose, onSuccess, user }: DeleteUserModalProps): ReactElement => {
	const token = useAppSelector((x) => x.profile.token);
	const { dispatchSetAxiosErrorMessage, dispatchSetMessageAction } = useMessagesDispatch();

	const handleDelete = async (): Promise<void> => {
		if (!user) return;

		try {
			const url = getApiUrl(ApiUrl.UsersUser).replace(':userId', user.id.toString());
			const axios = getAxiosInstance(token);
			await axios.delete(url);
			dispatchSetMessageAction('User deleted successfully', MessageStatusLevel.Success);
			onSuccess();
			onClose();
		} catch (e) {
			dispatchSetAxiosErrorMessage(e);
		}
	};

	return (
		<ConfirmModal
			open={isOpen}
			onClose={onClose}
			onConfirmClicked={handleDelete}
			title="Delete User"
			confirmButtonText="Delete"
			closeButtonText="Cancel"
		>
			<Typography variant="body1">
				Are you sure you want to delete user <b>{user?.email}</b>? This action cannot be undone.
			</Typography>
		</ConfirmModal>
	);
};

export default DeleteUserModal;
